"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProcessingStatusDetails = exports.DefaultVideoThumbnail = exports.DefaultThumbnailLogo = exports.RecordingStatus = exports.VideoThumbnail = exports.RecordingCardActionLink = exports.RecordingCardActionItem = exports.DetailsFooterContainer = exports.DetailsContainer = exports.ActionMenuButton = exports.PlayButton = exports.VideoOverlay = exports.VideoOverlayWrapper = exports.VideoContainer = exports.TileSubtitleText = exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_badge_1 = require("@hopin-team/ui-badge");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var ui_card_1 = require("@hopin-team/ui-card");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_icon_1 = require("@hopin-team/ui-icon");

var ui_logo_1 = require("@hopin-team/ui-logo");

var ui_menu_1 = require("@hopin-team/ui-menu");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.Root = (0, styled_components_1.default)(ui_card_1.Card)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 16.875rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 16.875rem;\n"])));
exports.TileSubtitleText = (0, styled_components_1.default)(ui_text_1.Text).attrs({
  color: 'grey-600',
  pattern: 'caption',
  mb: 1
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  min-height: 1.5rem;\n"], ["\n  min-height: 1.5rem;\n"])));
exports.VideoContainer = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  flexDirection: 'column'
})(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  max-width: 16.875rem;\n  height: 9.485rem;\n\n  video {\n    max-width: 16.875rem;\n    height: 9.485rem;\n  }\n"], ["\n  position: relative;\n  max-width: 16.875rem;\n  height: 9.485rem;\n\n  video {\n    max-width: 16.875rem;\n    height: 9.485rem;\n  }\n"])));
exports.VideoOverlayWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n"])));
exports.VideoOverlay = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  alignItems: 'center',
  justifyContent: 'center'
})(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  cursor: pointer;\n  border-radius: ", ";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  transition: background-color 0.2s ease-in, opacity 0.2s ease-in;\n\n  &:focus-within,\n  ", ":hover & {\n    background: ", ";\n    opacity: 0.8;\n  }\n"], ["\n  cursor: pointer;\n  border-radius: ", ";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  transition: background-color 0.2s ease-in, opacity 0.2s ease-in;\n\n  &:focus-within,\n  ", ":hover & {\n    background: ", ";\n    opacity: 0.8;\n  }\n"])), function (_a) {
  var fullRounded = _a.fullRounded;
  return fullRounded ? '0.75rem' : '0.75rem 0.75rem 0 0';
}, exports.VideoContainer, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DARK', theme);
});
exports.PlayButton = (0, styled_components_1.default)(ui_butticon_1.Butticon)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n\n  &:focus,\n  &:hover {\n    background: ", ";\n  }\n\n  ", " {\n    color: ", ";\n    padding: 0.3rem;\n  }\n"], ["\n  background: ", ";\n\n  &:focus,\n  &:hover {\n    background: ", ";\n  }\n\n  ", " {\n    color: ", ";\n    padding: 0.3rem;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
}, ui_icon_1.Icon, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
});
exports.ActionMenuButton = (0, styled_components_1.default)(ui_butticon_1.Butticon).attrs({
  mr: -1
})(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  background: transparent;\n  border: none;\n  width: auto;\n\n  &:hover {\n    background: transparent;\n    border: none;\n    transition: none;\n  }\n\n  ", " {\n    max-width: 0.8rem;\n    max-height: 0.8rem;\n    color: ", ";\n  }\n"], ["\n  background: transparent;\n  border: none;\n  width: auto;\n\n  &:hover {\n    background: transparent;\n    border: none;\n    transition: none;\n  }\n\n  ", " {\n    max-width: 0.8rem;\n    max-height: 0.8rem;\n    color: ", ";\n  }\n"])), ui_icon_1.Icon, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.MEDIUM', theme);
});
exports.DetailsContainer = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  px: 2,
  pb: 2,
  pt: 1.5,
  flexDirection: 'column',
  justifyContent: 'space-between'
})(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  min-height: 9.375rem;\n"], ["\n  min-height: 9.375rem;\n"])));
exports.DetailsFooterContainer = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  alignItems: 'center',
  px: 2,
  py: 1
})(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  border-top: 1px solid ", ";\n"], ["\n  border-top: 1px solid ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.300', theme);
});
var basicActionStyles = {
  py: 1,
  px: 1.5
};
exports.RecordingCardActionItem = (0, styled_components_1.default)(ui_menu_1.MenuSelectItem).attrs(basicActionStyles)(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject([""], [""])));
exports.RecordingCardActionLink = (0, styled_components_1.default)(ui_menu_1.MenuSelectLink).attrs(basicActionStyles)(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject([""], [""])));
exports.VideoThumbnail = styled_components_1.default.img(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"])));
exports.RecordingStatus = (0, styled_components_1.default)(ui_badge_1.Badge).attrs({
  mt: 2,
  ml: 2
})(templateObject_13 || (templateObject_13 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n\n  ", " {\n    font-weight: ", ";\n  }\n"], ["\n  position: absolute;\n\n  ", " {\n    font-weight: ", ";\n  }\n"])), ui_text_1.Text, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.MEDIUM', theme);
});
exports.DefaultThumbnailLogo = (0, styled_components_1.default)(ui_logo_1.Logo).attrs(function (_a) {
  var theme = _a.theme;
  return {
    type: 'hopin-pictorial',
    color: (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.400', theme)
  };
})(templateObject_14 || (templateObject_14 = tslib_1.__makeTemplateObject([""], [""])));
exports.DefaultVideoThumbnail = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  children: react_1.default.createElement(exports.DefaultThumbnailLogo, null)
})(templateObject_15 || (templateObject_15 = tslib_1.__makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  background-color: ", ";\n\n  ", " {\n    align-self: center;\n    margin: auto;\n  }\n"], ["\n  height: 100%;\n  width: 100%;\n  background-color: ", ";\n\n  ", " {\n    align-self: center;\n    margin: auto;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.500', theme);
}, exports.DefaultThumbnailLogo);
exports.ProcessingStatusDetails = (0, styled_components_1.default)(ui_text_1.Text).attrs({
  color: 'grey-600',
  pattern: 'caption'
})(templateObject_16 || (templateObject_16 = tslib_1.__makeTemplateObject(["\n  letter-spacing: 0.02em;\n"], ["\n  letter-spacing: 0.02em;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;